import Error from '../common/errorData'
import CON from '../constant'
import {
  http
} from './index'
const pasurl = CON.URL_DOWN
const getReq = (url, data) => { // 封装get参数
  const urls = http.adornUrl(url, pasurl)
  return http.get(urls, {
    params: data
  })
}
const postReq = (url, data) => { // 封装get参数
  const urls = http.adornUrl(url, pasurl)
  return http.post(urls, data)
}
export default {
// 接口提供者:
  login: (data) => postReq('/app-api/member/auth/login', data).then(Error),
  refreshToken: (data) => postReq('/admin-api/system/auth/refresh-token', data).then(Error),
  logout: (data) => postReq('/app-api/member/auth/logout', data).then(Error),
  getLoginStatus: (data) => getReq('/app-api/member/auth/getLoginStatus', data)
}
